// extracted by mini-css-extract-plugin
module.exports = {"calendar_icon":"DateInput_calendar_icon__1C-n1"};